import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { ApolloProvider } from '@apollo/client';
import { configureStore } from './redux/store';
import reportWebVitals from './reportWebVitals';

import client from './libs/apollo-client';

const { store, persistor } = configureStore();
const App = React.lazy(() => import(/* webpackChunkName: "App" */ './App'));

const Main = () => {
  return (
    <Provider store={store}>
      <ApolloProvider client={client}>
        <Suspense fallback={<div className="loading" />}>
          <PersistGate loading={null} persistor={persistor}>
            <App />
          </PersistGate>
        </Suspense>
      </ApolloProvider>
    </Provider>
  );
};

ReactDOM.render(<Main />, document.getElementById('root'));

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
